import type { ProductVariant } from "../types";

// utils/variantHelpers.ts
// export const getVariantFieldChange = (
//     variant: ProductVariant,
//     fieldName: string,
//     isReviewMode: boolean
// ) => {
//     if (!isReviewMode || !variant._action) {
//         return { value: variant[fieldName], previous: undefined, hasChanged: false };
//     }

//     if (variant._action === 'added') {
//         return {
//             value: variant[fieldName],
//             previous: undefined,
//             hasChanged: true
//         };
//     }

//     if (variant._action === 'changed' && variant._changed_fields?.[fieldName]) {
//         const change = variant._changed_fields[fieldName];
//         return {
//             value: change.new,
//             previous: change.old,
//             hasChanged: true
//         };
//     }

//     return {
//         value: variant[fieldName],
//         previous: undefined,
//         hasChanged: false
//     };
// };

// export const getVariantStatus = (variant: ProductVariant, isReviewMode: boolean) => {
//     if (!isReviewMode) return 'existing';
//     return variant._action || 'existing';
// };

export const getVariantSpecChange = (
    variant: ProductVariant,
    specKey: string,
    isReviewMode: boolean
) => {
    if (!isReviewMode || !variant._action) {
        return { hasChanged: false, oldKey: undefined, oldValue: undefined };
    }

    if (variant._action === 'changed' && variant.changed_fields?.specs) {
        const specChanges = variant.changed_fields.specs.changes || [];
        const specChange = specChanges.find(s => s.key === specKey);

        if (specChange) {
            return {
                hasChanged: true,
                oldKey: specChange.old_key,
                oldValue: specChange.old_value
            };
        }
    }

    return { hasChanged: false, oldKey: undefined, oldValue: undefined };
};

// Status styles
export const getStatusStyles = (variantStatus: string) => {
    switch (variantStatus) {
        case 'added':
            return 'border-green-400 bg-green-50';
        case 'removed':
            return 'border-red-400 bg-red-50 opacity-60';
        case 'changed':
            return 'border-blue-400 bg-blue-50';
        default:
            return 'border-gray-200';
    }
};

export const buildVariantFullSpecsWithChanges = (variant: ProductVariant) => {
    const currentSpecs = variant.specs || [];
    const specChanges = variant._changed_fields?.specs?.changes || [];

    // Build full list with actions
    const fullSpecs = currentSpecs.map(spec => ({
        ...spec,
        action: 'unchanged'
    }));

    specChanges.forEach(change => {
        const index = fullSpecs.findIndex(s => s.key === change.key);
        if (change.action === 'removed') {
            if (index !== -1) {
                fullSpecs[index].action = 'removed';
                fullSpecs[index].old_value = change.old_value;
                fullSpecs[index].value = change.old_value;
            }
        } else if (change.action === 'added' || change.action === 'changed') {
            if (index !== -1) {
                fullSpecs[index].action = change.action;
                fullSpecs[index].value = change.new_value;
                fullSpecs[index].old_value = change.old_value;
            } else {
                fullSpecs.push({
                    key: change.key,
                    value: change.new_value,
                    action: change.action,
                    old_value: change.old_value
                });
            }
        }
    });

    return fullSpecs;
};

// variantHelpers.ts

export const getVariantStatus = (variant: ProductVariant, isReviewMode: boolean) => {
    if (!isReviewMode) return 'existing';
    return variant._action || 'existing';
};

export const getVariantFieldChange = (
    variant: ProductVariant,
    fieldName: string,
    isReviewMode: boolean
) => {
    if (!isReviewMode || !variant._action) {
        return { value: variant[fieldName], previous: undefined, hasChanged: false };
    }

    if (variant._action === 'added') {
        return {
            value: variant[fieldName],
            previous: undefined,
            hasChanged: true
        };
    }

    if (variant._action === 'changed' && variant._changed_fields?.[fieldName]) {
        const change = variant._changed_fields[fieldName];
        return {
            value: change.new,
            previous: change.old,
            hasChanged: true
        };
    }

    return {
        value: variant[fieldName],
        previous: undefined,
        hasChanged: false
    };
};

export const getVariantSpecChanges = (variant: ProductVariant, isReviewMode: boolean) => {
    if (!isReviewMode || !variant._action) return null;
    return variant._changed_fields?.specs || null;
};